import modules from './modules'
import branches from './branches'
import settings from './settings'
import products from './products'
import logistics from './logistics'
import requests from './requests'
import supply_chain from './supply_chain'

export default {
    modules,
    branches,
    settings,
    products,
    logistics,
    requests,
    supply_chain
}